// extracted by mini-css-extract-plugin
var _1 = "assets-js-common-components-MegaNav-MegaNavVariant-components-GlobalNav-components-Login-components-AccountPreview-components-AccountDetailsDrawer-components-AcctDrawerItem-AcctDrawerItem-module__drawerCtaItem__W2H7V";
export { _1 as "drawerCtaItem" }
